<div class="modal-block">
  <h2 mat-dialog-title class="modal-title">Change Password</h2>
  <div mat-dialog-content class="modal-body">
    <form [formGroup]="changePasswordForm" (ngSubmit)="changePassword()">
      <!-- Old Password -->
      <mat-form-field appearance="fill" class="w-100">
        <mat-label>Old Password</mat-label>
        <input matInput type="password" formControlName="oldPassword" />
        <mat-error *ngIf="submitted && changePasswordForm.get('oldPassword')?.hasError('required')">
          Old Password is required
        </mat-error>
      </mat-form-field>

      <!-- New Password -->
      <mat-form-field appearance="fill" class="w-100">
        <mat-label>New Password</mat-label>
        <input matInput type="password" formControlName="newPassword" />
        <mat-error *ngIf="submitted && changePasswordForm.get('newPassword')?.hasError('required')">
          New Password is required
        </mat-error>
      </mat-form-field>

      <!-- Confirm Password -->
      <mat-form-field appearance="fill" class="w-100">
        <mat-label>Confirm New Password</mat-label>
        <input matInput type="password" formControlName="confirmNewPassword" />
        <mat-error *ngIf="submitted && changePasswordForm.get('confirmNewPassword')?.hasError('required')">
          Confirm New Password is required
        </mat-error>
        <mat-error *ngIf="submitted && changePasswordForm.hasError('passwordMismatch')">
          New Password and Confirm Password do not match
        </mat-error>
      </mat-form-field>

      <!-- Buttons -->
      <div class="d-flex justify-content-end gap-2 mt-3">
        <button mat-raised-button color="primary" type="submit">Save</button>
        <button mat-button type="button" (click)="closeModal()">Cancel</button>
      </div>
    </form>
  </div>
</div>
